export class OAuthTokenProvider {
}
class NullOAuthTokenProvider extends OAuthTokenProvider {
    getToken(context) {
        return Promise.resolve('');
    }
}
export const NullAuthTokenProvider = new NullOAuthTokenProvider();
export const OAUTH_TOKEN_PROVIDER = Symbol.for('OAuthTokenProvider');
//# sourceMappingURL=OAuthTokenProvider.js.map